import React, { useEffect, useState } from "react";
import "../App.css";
import Nav from "./Navigation.js";

export default function StatsItems() {
  const [allItems, setAllItems] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState("");
  const [itemVisibility, setItemVisibility] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [countAccounts, setCountAccounts] = useState(0);

  const fetchData = async () => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}/api/items`;
      const response = await fetch(url);
      const completeList = await response.json();

      const itemCheckCounts = await Promise.all(
        completeList.map(async (item) => {
          const checkUrl = `${process.env.REACT_APP_API_HOST}/items/${item.id}/users/checked`;
          const checkResponse = await fetch(checkUrl);
          const counting = await checkResponse.json();
          return { itemId: item.id, count: counting.length };
        })
      );

      const itemsWithCheckCounts = completeList.map((item) => {
        const checkCount = itemCheckCounts.find((check) => check.itemId === item.id)?.count || 0;
        return { ...item, checkCount };
      });

      setAllItems(itemsWithCheckCounts);
    } catch (error) {
      console.error("Error fetching items data: ", error);
    }
  };

  const fetchAccounts = async () => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}/api/accounts`;
      const response = await fetch(url);
      const completeList = await response.json();
      setCountAccounts(completeList.length);
    } catch (error) {
      console.error("Error fetching accounts data: ", error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchAccounts();
  }, []);

  const handleEventSelection = (e) => {
    const selectedValue = e.target.value;
    setSelectedEvent(selectedValue);
  };

  const handleClearSelection = () => {
    setSelectedEvent("");
    setSearchTerm("");
  };

  const toggleVisibility = (itemName) => {
    setItemVisibility((prevVisibility) => ({
      ...prevVisibility,
      [itemName]: !prevVisibility[itemName],
    }));
  };

  const selectedEvents = allItems.filter((item) => {
    if (
      selectedEvent === "" &&
      (searchTerm === "" ||
        item.name.toLowerCase().includes(searchTerm.toLowerCase()))
    ) {
      return true;
    } else {
      return (
        item.event === selectedEvent &&
        (searchTerm === "" ||
          item.name.toLowerCase().includes(searchTerm.toLowerCase()))
      );
    }
  });

  const sortedEvents = selectedEvents.sort((a, b) => {
    const percentageA = countAccounts > 0 ? (a.checkCount / countAccounts) * 100 : 0;
    const percentageB = countAccounts > 0 ? (b.checkCount / countAccounts) * 100 : 0;

    if (percentageA !== percentageB) {
      return percentageA - percentageB; // Sort by percentage rarity
    }
    return a.name.localeCompare(b.name); // Then alphabetically
  });

  return (
    <div>
      <Nav />
      <div className="text-white">
        <div className="Title">Complete List of Items</div>
        <div className="mb-4">
          <label htmlFor="eventDropdown" className="text-md font-bold">
            Select Event:
          </label>
          <select
            id="eventDropdown"
            onChange={handleEventSelection}
            value={selectedEvent}
            className="ml-2 p-1 border rounded text-black"
          >
            <option value="">All</option>
            {Array.from(new Set(allItems.map((item) => item.event))).map(
              (event) => (
                <option key={event} value={event}>
                  {event}
                </option>
              )
            )}
          </select>
          Or search
          <input
            type="text"
            placeholder="Search by name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="ml-2 p-1 border rounded text-black"
          />
          <button
            onClick={handleClearSelection}
            className="ml-2 p-1 border rounded"
          >
            Reset/Clear
          </button>
        </div>

        <div className="flex flex-wrap">
          {Array.from(
            new Set(
              sortedEvents
                // .sort((a, b) => a.name.localeCompare(b.name))
                .map((item) => item.maps)
            )
          ).map((map) => (
            <div key={map} className="mb-6 ml-2 w-full">
              <h3 className="text-lg font-bold mb-2">{map} Maps</h3>
              {Array.from(
                new Set(
                  sortedEvents
                    .filter((item) => item.maps === map)
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((item) => item.types)
                )
              ).map((type) => (
                <div key={type} className="mb-4">
                  <h4 className="text-md font-bold mb-2">{type} Types</h4>
                  <div className="grid gap-2 grid-cols-1 md:grid-cols-1">
                    {sortedEvents
                      .filter(
                        (item) => item.maps === map && item.types === type
                      )
                      .map((filteredItem) => (
                        <div className="border-b-2" key={filteredItem.id}>
                          <div className="grid grid-cols-4 gap-4 items-center">
                            <div className="border p-2 rounded flex">
                                                            <button
                                className="bg-blue-500 border-solid border-2 border-white text-white rounded"
                                onClick={() => toggleVisibility(filteredItem.name)}
                              >
                                {itemVisibility[filteredItem.name] ? "Hide" : "Info"}
                              </button>
                              <div className="font-bold ml-2">{filteredItem.name}</div>
                            </div>
                            {/* <div>
                              <button
                                className="bg-blue-500 border-solid border-2 border-white text-white px-2 py-1 rounded"
                                onClick={() => toggleVisibility(filteredItem.name)}
                              >
                                {itemVisibility[filteredItem.name] ? "Hide" : "Info"}
                              </button>
                            </div> */}
                            <div className="p-2 flex">
                              <div className="font-bold pr-2">Owned By:</div>
                              <div>{filteredItem.checkCount}</div>
                            </div>
                            <div className="p-2 flex">
                              <div className="font-bold pr-2">Percentage:</div>
                              <div>{countAccounts > 0 ? (filteredItem.checkCount / countAccounts * 100).toFixed(2) : 0}%</div>
                            </div>
                          </div>
                          {itemVisibility[filteredItem.name] && (
                            <div className="mt-2">
                              <img
                                className="object-scale-down h-48 cursor-pointer"
                                src={require(`../imagesitems/${filteredItem.url}`)}
                                alt={"no image"}
                              />
                            </div>
                          )}
                        </div>
                      ))}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}


// import React, { useEffect, useState } from "react";
// import "../App.css";
// import Nav from "./Navigation.js";

// export default function StatsItems() {
//   const [allItems, setAllItems] = useState([]);
//   const [selectedEvent, setSelectedEvent] = useState("");
//   const [itemVisibility, setItemVisibility] = useState({});
//   const [searchTerm, setSearchTerm] = useState("");
//   const [countAccounts, setCountAccounts] = useState(0);

//   const fetchData = async () => {
//     try {
//       const url = ${process.env.REACT_APP_API_HOST}/api/items;
//       const response = await fetch(url);
//       const completeList = await response.json();

//   const itemCheckCounts = await Promise.all(
//     completeList.map(async (item) => {
//       const checkUrl = ${process.env.REACT_APP_API_HOST}/items/${item.id}/users/checked;
//       const checkResponse = await fetch(checkUrl);
//       const counting = await checkResponse.json();
//       return { itemId: item.id, count: counting.length }; // Use 'count' for consistency
//     })
//   );


//     const itemsWithCheckCounts = completeList.map((item) => {
//       const checkCount = itemCheckCounts.find((check) => check.itemId === item.id)?.count || 0;
//       return { ...item, checkCount };
//     });


//       setAllItems(itemsWithCheckCounts);
//     } catch (error) {
//       console.error("Error fetching items data: ", error);
//     }
//   };

//   const fetchAccounts = async () => {
//     try {
//       const url = ${process.env.REACT_APP_API_HOST}/api/accounts;
//       const response = await fetch(url);
//       const completeList = await response.json();
//       setCountAccounts(completeList.length);
//     } catch (error) {
//       console.error("Error fetching accounts data: ", error);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//     fetchAccounts();
//   }, []);

//   const handleEventSelection = (e) => {
//     const selectedValue = e.target.value;
//     setSelectedEvent(selectedValue);
//   };

//   const handleClearSelection = () => {
//     setSelectedEvent("");
//     setSearchTerm("");
//   };

//   const toggleVisibility = (itemName) => {
//     setItemVisibility((prevVisibility) => ({
//       ...prevVisibility,
//       [itemName]: !prevVisibility[itemName],
//     }));
//   };

//   const selectedEvents = allItems.filter((item) => {
//     if (
//       selectedEvent === "" &&
//       (searchTerm === "" ||
//         item.name.toLowerCase().includes(searchTerm.toLowerCase()))
//     ) {
//       return true;
//     } else {
//       return (
//         item.event === selectedEvent &&
//         (searchTerm === "" ||
//           item.name.toLowerCase().includes(searchTerm.toLowerCase()))
//       );
//     }
//   });

//   return (
//     <div>
//       <Nav />
//       <div className="text-white">
//         <div className="Title">Complete List of Items</div>
//         <div className="mb-4">
//           <label htmlFor="eventDropdown" className="text-md font-bold">
//             Select Event:
//           </label>
//           <select
//             id="eventDropdown"
//             onChange={handleEventSelection}
//             value={selectedEvent}
//             className="ml-2 p-1 border rounded text-black"
//           >
//             <option value="">All</option>
//             {Array.from(new Set(allItems.map((item) => item.event))).map(
//               (event) => (
//                 <option key={event} value={event}>
//                   {event}
//                 </option>
//               )
//             )}
//           </select>
//           Or search
//           <input
//             type="text"
//             placeholder="Search by name..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="ml-2 p-1 border rounded text-black"
//           />
//           <button
//             onClick={handleClearSelection}
//             className="ml-2 p-1 border rounded"
//           >
//             Reset/Clear
//           </button>
//         </div>

//         <div className="flex flex-wrap">
//           {Array.from(
//             new Set(
//               selectedEvents
//                 .sort((a, b) => a.name.localeCompare(b.name))
//                 .map((item) => item.maps)
//             )
//           ).map((map) => (
//             <div key={map} className="mb-6 ml-2 w-full">
//               <h3 className="text-lg font-bold mb-2">{map} Maps</h3>
//               {Array.from(
//                 new Set(
//                   selectedEvents
//                     .filter((item) => item.maps === map)
//                     .sort((a, b) => a.name.localeCompare(b.name))
//                     .map((item) => item.types)
//                 )
//               ).map((type) => (
//                 <div key={type} className="mb-4">
//                   <h4 className="text-md font-bold mb-2">{type} Types</h4>
//                   <div className="grid gap-2 grid-cols-1 md:grid-cols-1">
//                     {selectedEvents
//                       .filter(
//                         (item) => item.maps === map && item.types === type
//                       )
//                       .map((filteredItem) => (
//                         <div className="border p-2 rounded" key={filteredItem.id}>
//                           <div className="grid grid-cols-4 gap-4 items-center">
//                             <div className="border p-2 rounded">
//                               <div className="font-bold">{filteredItem.name}</div>
//                             </div>
//                             <div>
//                               <button
//                                 className="bg-blue-500 border-solid border-2 border-white text-white px-2 py-1 rounded"
//                                 onClick={() => toggleVisibility(filteredItem.name)}
//                               >
//                                 {itemVisibility[filteredItem.name] ? "Hide" : "Info"}
//                               </button>
//                             </div>
//                             <div className="border p-2 rounded flex">
//                               <div className="font-bold pr-2">People who own:</div>
//                               <div>{filteredItem.checkCount}</div>
//                             </div>
//                             <div className="border p-2 rounded flex">
//                               <div className="font-bold pr-2">Percentage:</div>
//                               <div>{countAccounts > 0 ? (filteredItem.checkCount / countAccounts * 100).toFixed(2) : 0}%</div>
//                             </div>
//                           </div>
//                           {itemVisibility[filteredItem.name] && (
//                             <div className="mt-2">
//                               <img
//                                 className="object-scale-down h-48 cursor-pointer"
//                                 src={require(../imagesitems/${filteredItem.url})}
//                                 alt={"no image"}
//                               />
//                             </div>
//                           )}
//                         </div>
//                       ))}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }
